var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"widget-settings-flat-item"},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1),_c('v-list-item-action',{staticClass:"mr-3"},[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }